import { z } from 'zod';

/** カテゴリは ShiftAlertType + "all"。表示順を保つため明示列挙する。 */
export const SHIFT_ALERT_CATEGORY_VALUES = ['all', 'unqualified_sales_risk', 'understaffed', 'labor_cost_over', 'overtime_over'] as const;
export type ShiftAlertCategory = (typeof SHIFT_ALERT_CATEGORY_VALUES)[number];
export const ShiftAlertsSearchSchema = z.object({
  category: z.enum(SHIFT_ALERT_CATEGORY_VALUES).default('all'),
  freeText: z.string().optional(),
  severity: z.enum(['all', 'warning', 'critical']).default('all'),
  status: z.enum(['all', 'open', 'requested', 'resolved']).default('all'),
  pageIndex: z.coerce.number().default(0),
  pageSize: z.coerce.number().default(50)
});
export type ShiftAlertsSearchParams = z.infer<typeof ShiftAlertsSearchSchema>;